<template>
  <div
    class="rounded shadow-sm min-h-32 border p-4 flex mb-4 knowledge-list"
    @click="redirectToCategory"
  >
    <div class="w-12 pr-4" v-if="taxon.icon">
      <img v-if="taxon.icon" :src="taxon.icon" />
    </div>
    <div class="flex-1">
      <div class="knowledge-list-heading">{{ taxon.name }}</div>
      <div class="knowledge-list-content">{{ taxon.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
    name: "Taxon",
    props: ["taxon"],
    methods: {
        redirectToCategory() {
            this.$router.push({
                name: "KnowledgeTaxon",
                params: { slug: this.taxon.slug }
            });
        }
    }
};
</script>

<style>
.knowledge-list {
  background: var(--knowledge-list-background);
}
.knowledge-list-heading {
  color: var(--knowledge-list-heading-color);
  font-size: var(--knowledge-list-heading-font-size);
  font-weight: var(--knowledge-list-heading-font-weight);
  line-height: var(--knowledge-list-heading-line-height);
}

.knowledge-list-content {
  color: var(--knowledge-list-content-color);
  font-size: var(--knowledge-list-content-font-size);
  font-weight: var(--knowledge-list-content-font-weight);
  line-height: var(--knowledge-list-content-line-height);
}
</style>
